import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  DateRangePicker,
  isInclusivelyBeforeDay,
  isInclusivelyAfterDay
} from 'react-dates';
import moment from 'moment';
import './style.css';
import * as actions from '../../../actions';

class DatePicker extends Component {
  shouldComponentUpdate(nextProps) {
    const { startDate, endDate, focusedInput } = this.props;
    const isStartDateDifferent = startDate !== nextProps.startDate;
    const isEndDateDifferent = endDate !== nextProps.endDate;
    const isFocusInputDifferent = focusedInput !== nextProps.focusedInput;

    if (nextProps.endDate < nextProps.startDate) {
      return false;
    }

    return isStartDateDifferent || isEndDateDifferent || isFocusInputDifferent;
  }

  render() {
    return (
      <div style={{ zIndex: 5 }}>
        <DateRangePicker
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onDatesChange={({ startDate, endDate }) => {
            this.props.setDate(startDate, endDate);
          }}
          focusedInput={this.props.focusedInput}
          minimumNights={0}
          hideKeyboardShortcutsPanel={true}
          displayFormat="MMM D, YYYY"
          onFocusChange={focusedInput => {
            const { $ } = window;
            $('select.date-preset-input').find('option[value="custom"]').prop('selected', true);
            $('select.date-preset-input').material_select();

            this.props.setFocusedInput(focusedInput)
          }}
          isOutsideRange={day => {
            const dataStart = moment().subtract(16, 'months');
            const dataEnd = moment().subtract(1, 'day');
            return (
              !isInclusivelyBeforeDay(day, dataEnd) ||
              !isInclusivelyAfterDay(day, dataStart)
            );
          }}
        />
      </div>
    );
  }
}

function mapStateToProps({
  startDate,
  endDate,
  focusedInput,
  selectedPage,
  positionFilter,
  selectedMetric,
  country
}) {
  return {
    startDate,
    endDate,
    focusedInput,
    selectedPage,
    positionFilter,
    selectedMetric,
    country
  };
}

export default connect(mapStateToProps, actions)(DatePicker);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DatePicker/index.js